import { render, staticRenderFns } from "./FeatureDetails.vue?vue&type=template&id=43835000&scoped=true&"
import script from "./FeatureDetails.vue?vue&type=script&lang=js&"
export * from "./FeatureDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeatureDetails.scss?vue&type=style&index=0&id=43835000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43835000",
  null
  
)

export default component.exports